import { render, staticRenderFns } from "./Examination.vue?vue&type=template&id=01422de8"
import script from "./Examination.vue?vue&type=script&lang=js"
export * from "./Examination.vue?vue&type=script&lang=js"
import style0 from "./Examination.vue?vue&type=style&index=0&id=01422de8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports